import apiCallTemplate from './config'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const platformURL = `${BASE_URL}/platforms`;

//create platform
export const createPlatform=async (data)=>apiCallTemplate("post", platformURL, data, true)

//all platform
export const AllPlatforms=async ()=>apiCallTemplate("get", platformURL)

//Get platform by id
export const getplatformById=async (id)=>apiCallTemplate("get", `${platformURL}/${id}`)

//Update platform 
export const updateplatform=async (id, data)=>apiCallTemplate("put", `${platformURL}/${id}`, data)

//Delete platform
export const deleteplatform=async (id)=>apiCallTemplate("delete", `${platformURL}/${id}`)
